import React from "react"
import FormFinancierBatch from "./Form"
import ManageFinancierBatch from "./ManageItem"

export default function UpdateFinancierBatch({ params }) {

  return <ManageFinancierBatch
    params={ params }
    callback={ data =>
      <FormFinancierBatch financierBatch={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/Update.js